import { action } from "../utils/requests"

export const getPosts = (data = {}) => {

	data = data.hasOwnProperty('post_type') ? data : { post_type: 'post', ...data }

	return action('argus_posts', data);
}
